import clsx from "clsx";
import { useEffect, useState } from "react";

import classes from "./styles.module.scss";

import { Icon } from "@components/atoms/icons";
import { InputV2 } from "@components/formControls";
import { Typography } from "@components/atoms/typography";
import type { IFilterProps } from "@components/molecules/filter/types";
import { FilterSelect } from "@components/molecules/filter/components/filterSelect";
import {
  clearAllFilters,
  normalizeFilterValues,
} from "@components/molecules/filter/helper";
import { InputBGIcon } from "@/components/formControls/formControl";

export function Filter(props: IFilterProps) {
  // TODO ICON CLICK BUG
  const {
    // index,
    options,
    value: rawValue,
    onFilterSelect,
    containerClassname,
    contentClassname,
    // setToUrl,
  } = props;

  const value = normalizeFilterValues(options, rawValue);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const func = () => {
      setOpen(false);
    };

    document.addEventListener("click", func);

    return () => {
      document.removeEventListener("click", func);
    };
  }, []);

  return (
    <div
      className={clsx(classes.filter__container, containerClassname)}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <label className={clsx(classes.filter__label)}>
        <Icon name={"Filter"} />
        <Typography fontSize={"md-high"}>{"فیلتر"}</Typography>
      </label>
      <InputV2
        containerClassName={"cursor-pointer"}
        containerOnClick={() => {
          setOpen(true);
        }}
        placeholder={"فیلتر"}
        bgIcon={
          <InputBGIcon>
            <Icon name={"AltArrowDown"} />
          </InputBGIcon>
        }
        className={clsx(classes.filter)}
        // onClick={() => setOpen(true)}
        value={""}
      />
      <div
        className={clsx(
          classes.filter__inside,
          contentClassname,
          open && classes.filter__insideOpen,
        )}
      >
        <div className={clsx(classes.filter__item, classes.filter__head)}>
          <Typography fontSize={"base"} fontWeight={"semi-bold"}>
            {"فیلتر\r"}
          </Typography>
          <Typography
            variant={"caption1"}
            color={"primary-main"}
            className={classes.filter__pointer}
            htmlAttribute={{
              onClick: () => {
                clearAllFilters(onFilterSelect);
              },
            }}
          >
            {"پاک کردن همه\r"}
          </Typography>
        </div>
        <div className={clsx(classes.filter__allItems)}>
          {options?.map((option, index) => (
            <FilterSelect
              index={index}
              content={option}
              value={value}
              options={options}
              onFilterSelect={onFilterSelect}
              key={option?.key}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
